import React, { useRef, useState, useEffect } from 'react';
import { IApplicationState } from '../../store';
import BrazeEvents from '../../helpers/braze';
import useExitDetection from './exit-detection';
import { useSelector } from 'react-redux';

const ExitIntentComponent = () => {
    const lastExitIntentTimeRef = useRef(0);
    const timeoutDuration = 5000;
    const userLang = useSelector((state: IApplicationState) => state.intl.momentLocale);
    const brazeUserLang = userLang.length > 2 ? userLang.slice(0, 2) : userLang;

    const handleExitIntent = (eventType: any) => {
        const now = Date.now();
        const url = window.location.href;

        if (now - lastExitIntentTimeRef.current >= timeoutDuration) {
            BrazeEvents.LogExitIntent(url, brazeUserLang);

            lastExitIntentTimeRef.current = now;
        }
    };

    useExitDetection(handleExitIntent);

    return <></>;
};

export default ExitIntentComponent;
